import { ReactNode, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button, Heading, Modal, Paragraph, Popover } from '@treams/treams-ui';

import OverviewItem from './OverviewItem';
import WorkspaceFeatures from 'packages/kakapo-ui-settings-application/pages/organization/settings/WorkspaceFeatures';

const Grid = styled(Box)`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 8px;
`;

export default function OverviewSection(props: {
	title: string;
	description: string;
	color: string;
	items: {
		icon: ReactNode;
		title: string;
		link: string;
		enabled?: boolean;
		upsell?: ReactNode;
	}[];
}) {
	const [edit, setEdit] = useState(false);

	return (
		<Box>
			<Flex>
				<Box flexGrow={1} flexShrink={1}>
					<Heading mb={2}>{props.title}</Heading>
					<Paragraph color="slateBlue">{props.description}</Paragraph>
				</Box>
				<Box flexGrow={0} flexShrink={0} ml={2}>
					<Popover.Target
						center
						visible={edit}
						onDismiss={() => setEdit(false)}
						contents={
							<Modal>
								<Modal.Header title="Modules bewerken" onClose={() => setEdit(false)} />
								<Modal.Contents>
									<WorkspaceFeatures />
								</Modal.Contents>
							</Modal>
						}
					>
						<Button type="transparent" title="Bewerk modules" onClick={() => setEdit(true)} />
					</Popover.Target>
				</Box>
			</Flex>
			<Grid mt={3}>
				{props.items.map((item, i) => (
					<OverviewItem key={i} color={props.color} {...item} />
				))}
			</Grid>
		</Box>
	);
}
